import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export function FailedApproaches() {
  const approaches = [{
    title: 'Las agencias de reparación',
    desc: 'Su negocio no es arreglar tu crédito rápido, es mantenerte pagando una mensualidad el mayor tiempo posible.'
  }, {
    title: 'Ignorar el problema',
    desc: 'Las deudas en "collection" no desaparecen solas; se venden de una agencia a otra, manchando tu nombre por décadas.'
  }, {
    title: 'Pagar deudas viejas sin estrategia',
    desc: 'A veces, pagar una cuenta vieja reinicia el tiempo de castigo y baja tu puntaje en lugar de subirlo.'
  }];
  return <section className="py-20 bg-brand-dark text-brand-cream relative" data-id="element-13">
      <div className="container mx-auto px-6" data-id="element-14">
        <FadeIn data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-brand-gold" data-id="element-16">
            ¿Por qué lo que has intentado no funciona?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-17">
          {approaches.map((item, index) => <FadeIn key={index} delay={index * 0.2} direction="up" data-id="element-18">
              <div className="bg-white/5 p-8 rounded-xl border border-white/10 h-full hover:bg-white/10 transition-colors" data-id="element-19">
                <XCircle className="w-12 h-12 text-brand-coral mb-6" data-id="element-20" />
                <h3 className="text-xl font-bold mb-4 text-white" data-id="element-21">
                  {item.title}:
                </h3>
                <p className="text-brand-cream/80 leading-relaxed" data-id="element-22">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}